import Dashboard from "../pages/dashboard";
import AccountLogin from "../pages/accounts/login";
import UserList from "../pages/user-list";
import UserEdit from "../pages/user-list/edit";
import BuyerProfileEdit from "../pages/user-list/edit-buyer";
import TileTypes from "../pages/tile-types";
import TileSizes from "../pages/tile-sizes";
import TileList from "../pages/tile-list";
import SanitarywareTypes from "../pages/sanitaryware-types";
import SanitarywareList from "../pages/sanitaryware-list";
import SanitarywareAttributes from "../pages/sanitaryware-attributes";
import SubscriptionPlans from "../pages/subscription-plans";
import SubscriptionList from "../pages/subscription-list";
import BuyerInquiryList from "../pages/buyer-inquiry-list";
import SanitarywareInquiryClickList from "../pages/sanitaryware-inquiry-click-list";
import TileInquiryClickList from "../pages/tile-inquiry-click-list";
import BuyerInterests from "../pages/buyer-interests";
import BannerManagement from "../pages/banner-management";
import TransactionManagement from "../pages/transaction";
import InvoiceList from "../pages/invoice-list";

const AdminRoutes = [
  { path: "", component: <Dashboard /> },
  { path: "dashboard", component: <Dashboard /> },
  { path: "accounts/login", component: <AccountLogin /> },
  { path: "user-list", component: <UserList /> },
  { path: "user-seller/:id", component: <UserEdit /> },
  { path: "user-buyer/:id", component: <BuyerProfileEdit /> },
  { path: "tile-types", component: <TileTypes /> },
  { path: "tile-sizes", component: <TileSizes /> },
  { path: "tile-list", component: <TileList /> },
  { path: "sanitaryware-types", component: <SanitarywareTypes /> },
  { path: "sanitaryware-list", component: <SanitarywareList /> },
  { path: "sanitaryware-attributes", component: <SanitarywareAttributes /> },
  { path: "subscription-plans", component: <SubscriptionPlans /> },
  { path: "subscription-list", component: <SubscriptionList /> },
  { path: "buyer-inquiry-list", component: <BuyerInquiryList /> },
  { path: "sanitaryware-inquiry-click-list", component: <SanitarywareInquiryClickList /> },
  { path: "tile-inquiry-click-list", component: <TileInquiryClickList /> },
  { path: "buyer-interests", component: <BuyerInterests /> },
  { path: "banner-management", component: <BannerManagement /> },
  { path: "transaction", component: <TransactionManagement /> },
  { path: "invoice-list", component: <InvoiceList /> },

];

export default AdminRoutes;
